import { Directive, ElementRef, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SxMonitoringService } from 'app/services/sx-monitoring.service';
import * as fromAccountStore from '@appStore/account';
import * as fromStore from '@core/store';
import { SubSink } from 'subsink';

@Directive({
    selector: '[setInformationAsRead]',
    standalone: false
})
export class SetInformationAsReadDirective implements OnInit {

isImpersonating: any;
private subs = new SubSink();
 
  constructor(private el: ElementRef, 
    private router: Router, 
    private monitoringService: SxMonitoringService,
    private accountStore: Store<fromAccountStore.State>,
    private informationStore: Store<fromStore.InformationState>
    ) {}

  ngOnInit() {

    this.subs.sink = this.accountStore.select(fromAccountStore.getUserInfo).subscribe(userInfo => {
        this.isImpersonating = !!userInfo.impersonatedAsName;
    });
  }

  @HostListener('click', ['$event'])
  public onClick(eleRef) {

    const id = eleRef.currentTarget.getAttribute('id');

    if (id) {
        if (!this.isImpersonating) {
            this.informationStore.dispatch(new fromStore.InformationSetAsRead(id));
        }
    }
  }

}
